import React from 'react';
import { formatInTimezone } from '../../../utils/formatInTimezone';
import { getChangeTypeLabel, getFeatureIdDisplayName } from '../../../constants/analyticsConstants';
import { requestDisplayStatus } from '../../../utils/changeRequestStatus';
import RuleLink from '../components/RuleLink';

/**
 * Карточка заявки клиента (Part 4, раздел 7.2; ТЗ 29).
 *
 * Заявка — это предложение, а не изменение: карточка нигде не изображает
 * production-состояние применённым.
 *
 * ТЗ 29: главная строка — имя зоны/объекта заявки, а не служебный код типа
 * change_type; сам тип уходит подзаголовком. `request_id` — вспомогательная
 * деталь для сверки с backend-логами, а не заголовок карточки.
 */
const ChangeRequestCard = ({ request, onOpen, cameraLabel, extra = null }) => {
  const status = requestDisplayStatus(request);
  const impact = request.impact || {};
  const featuresToEnable = impact.features_to_enable || [];
  const affectedRules = impact.affected_rules || [];
  const typeLabel = getChangeTypeLabel(request.change_type);
  const title = request.payload?.display_name || request.zone_display_name || typeLabel;
  const cameraDisplay = cameraLabel || request.camera_name || `Камера #${request.camera_id}`;
  const requestId = request.change_request_id || '';

  return (
    <li className="vio-cr">
      <div className="vio-cr-head">
        <div className="vio-cr-title">
          <span className="vio-feature-name">{title}</span>
          {/* Тип дублировать текстом заголовка незачем — subtitle показывает
              его только когда заголовок содержит собственное имя объекта. */}
          {title !== typeLabel && <span className="vio-cr-subtitle">{typeLabel}</span>}
        </div>
        <span className={`vio-badge vio-badge--${status.modifier}`}>{status.label}</span>
      </div>

      <div className="vio-cr-meta">
        <span>{cameraDisplay}</span>
        <span>{request.proposed_by?.display_name || 'Клиент'}</span>
        {request.created_at && <span>{formatInTimezone(request.created_at)}</span>}
        {requestId && (
          <span className="vio-cr-id" title={requestId}>#{requestId.slice(0, 8)}</span>
        )}
      </div>

      {(featuresToEnable.length > 0 || affectedRules.length > 0) && (
        <div className="vio-feature-rules">
          {featuresToEnable.length > 0 && (
            <div>
              <span className="vio-feature-rules-title">Потребуется детекция: </span>
              {featuresToEnable.map(getFeatureIdDisplayName).join(', ')}
            </div>
          )}
          {affectedRules.length > 0 && (
            <div>
              <span className="vio-feature-rules-title">Затронутые правила: </span>
              {affectedRules.map((rule, index) => (
                <React.Fragment key={rule.rule_id || index}>
                  {index > 0 && ', '}
                  <RuleLink rule={rule} />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      )}

      {/* FE-FIX05: метаданные рассмотрения принадлежат карточке заявки,
          а не соседнему элементу списка. */}
      {extra && <div className="vio-cr-extra-body">{extra}</div>}

      <div className="vio-cell-actions">
        <button type="button" className="vio-btn vio-btn--link" onClick={() => onOpen(request)}>
          Подробнее
        </button>
      </div>
    </li>
  );
};

export default ChangeRequestCard;
